import {isAndroidWebView, isIOSWebView} from "../utils/helpers";
import { IOS_PRODUCT_ID, ANDROID_PRODUCT_ID } from "../utils/constants";
import ROUTES from "../utils/routes";

export default function useWebViewInAppBuyClick(gameId, location) {
  const handleBuyInAppWebViewClick = () => {
    if (isAndroidWebView()) {
      window.postMessage(
        JSON.stringify({
          type: "PRODUCT_PURCHASE",
          data: {
            platformProductId: ANDROID_PRODUCT_ID,
            ...(location.state &&
            (location.state.from === ROUTES.PERSONAL_ACCOUNT_PAGE)
              ? {}
              : gameId ? { gameId } : {}),
          },
        }),
        "*"
      );
    }

    if (isIOSWebView()) {
      window.postMessage(
        JSON.stringify({
          type: "PRODUCT_PURCHASE",
          data: {
            platformProductId: IOS_PRODUCT_ID,
            ...(location.state &&
            (location.state.from === ROUTES.PERSONAL_ACCOUNT_PAGE)
              ? {}
              : gameId ? { gameId } : {}),
          },
        }),
        "*"
      );
    }
  };

  return { handleBuyInAppWebViewClick };
}
